<template>
  <div id="app">
    <PublicHeader v-if="!hideHeader" />
    <router-view />
    <PublicFooter v-if="!hideFooter" />
    <!-- <div class="weihu-bg">
      <img src="/weihu.jpg">
    </div> -->
  </div>
</template>
<script>
import PublicHeader from './components/header.vue'
import PublicFooter from './components/footer.vue'
export default {
  name: 'App',
  components: { PublicHeader, PublicFooter },
  computed: {
    hideHeader: function () {
      const { hideHeader = false, n = '0' } = this.$route.query
      return hideHeader === 'true' || n === '1'
    },
    hideFooter: function () {
      const { hideFooter = false, n = '0' } = this.$route.query
      return hideFooter === 'true' || n === '1'
    }
  }
}
</script>

<style lang="scss" scoped>
#app {
  background: #eef3ff;
}
.weihu-bg {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba($color: #000000, $alpha: 0.8);
  z-index: 9999;
  img {
    max-width: 100%;
    max-height: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
